// «استعراض الطلاب» (/_students/list, views/students/list.vue): the server sends 100 students per page.
// «كل البيانات» = the same request with the page's current search / grade / class / order, page 1 and a large
// perpage (the page itself does this for its own Excel export). One request: the server cuts pages over the
// unfiltered list, so asking page after page with a filter could repeat students.
// `total` from the server counts every student of the school; `filtered_total` (newer servers) the ones matching
// the search / grade / class — without it a filtered list reads «كل البيانات» without a number.
import { ownerVm } from './util';

function jwt(){
  try { return JSON.parse(localStorage.getItem('user')).jwt || ''; } catch (e) { return ''; }
}

export default {
  name: 'students-list',
  selector: '#studentstable',
  match: function(route){ return route == '/_students/list'; },
  vm: function(el){
    return ownerVm(el, function(vm){ return Array.isArray(vm.students) && 'perpage' in vm && typeof vm.getStudents == 'function'; });
  },
  // { more, total|null }
  info: function(el){
    var vm = this.vm(el);
    if (!vm) return { more: false, total: null };
    var shown = vm.students.length;
    var per = parseInt(vm.perpage, 10) || 100;
    // fingerprint / app checks reload with a big page and filter in the browser: everything is shown
    var more = !vm.filtered && (parseInt(vm.page, 10) > 1 || shown >= Math.min(per, 99));
    var filtered = !!(vm.q || vm.classname || vm.classroom);
    // newer servers count the filtered students too (filtered_total); older ones only the whole school
    var total = filtered
      ? (vm.filtered_total != null ? parseInt(vm.filtered_total, 10) || 0 : null)
      : (vm.total ? parseInt(vm.total, 10) || null : null);
    return { more: more, total: more ? total : shown };
  },
  // → { promise: Promise<{ok, items, message}>, cancel }
  fetchAll: function(vm, opts){
    var xhr = null, cancelled = false;
    var promise = new Promise(function(resolve){
      opts.onProgress('جاري جلب كل الطلاب…', null);
      xhr = $.ajax({
        type: 'POST',
        url: window.api + '/user/students/list',
        data: { jwt: jwt(), q: vm.q, classname: vm.classname, classroom: vm.classroom, sort: vm.sort,
          page: 1, perpage: opts.cap + 1, allow: 'yes', nocheck: true },
        timeout: 120000,
        xhr: function(){
          var x = $.ajaxSettings.xhr();
          x.addEventListener('progress', function(e){
            if (e.lengthComputable && e.total) opts.onProgress('جاري جلب كل الطلاب…', e.loaded / e.total);
          });
          return x;
        },
      });
      xhr.then(function(r){
        if (r && r.status == 100 && Array.isArray(r.response)) resolve({ ok: true, items: r.response });
        else resolve({ ok: false, message: (r && typeof r.response == 'string' && r.response) || 'تعذّر جلب كل البيانات.' });
      }).fail(function(x, status){
        resolve({ ok: false, cancelled: cancelled, message: cancelled ? 'تم الإلغاء.' : status == 'timeout' ? 'تأخر جلب البيانات، حاول مرة أخرى.' : 'تعذّر جلب كل البيانات. تحقق من الإنترنت.' });
      });
    });
    return { promise: promise, cancel: function(){ cancelled = true; if (xhr) xhr.abort(); } };
  },
  // header label on the page → value of a student
  cells: {
    'الاسم': function(s){ return s.name; },
    'الهوية': function(s){ return s.number; },
    'الجوال': function(s){ return (s.phones || []).join(','); },
    'الصف': function(s){ return s.classname; },
    'الفصل': function(s){ return s.classroom; },
    'مجموعة الاعدادات': function(s, vm){ return vm.settingsGroupName ? vm.settingsGroupName(s.group_id) : ''; },
  },
};
